export default {
  init() {

  },
  finalize() {
    window.Am2AjaxFunctions.am2_load_more_courses();
    window.Am2AjaxFunctions.am2_load_more_full_time_courses();
    window.Am2AjaxFunctions.am2_load_more_part_time_courses();
    window.Am2AjaxFunctions.am2_load_more_apprenticeship_courses();
    window.Am2AjaxFunctions.am2_load_more_university_level_courses();
    window.Am2AjaxFunctions.am2_load_more_distance_learning_courses();
    window.Am2AjaxFunctions.am2_filter_courses_archive();
    window.Am2AjaxFunctions.am2_search_filters_course_area();
    window.Am2AjaxFunctions.am2_search_careers();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archive.js